import React from "react";
import styled from "styled-components";
import Paragraph from "../components/Paragraph";
import Col from "../components/Col";
import SubHeadline from "../components/SubHeadline";
import colors from "../config/colors";

const DoItems = styled.div``;

const Header = styled.div`
  display: flex;
`;

const Img = styled.img`
  width: 2.5rem;
  flex: 0 0 2.5rem;
  align-self: center;
`;

const HeaderHeadline = styled.div`
  flex: 1 1 auto;
  margin-left: 1rem;
`;

const Content = styled.div`
  margin-left: 3.5rem;
`;

const Row = styled.span`
  display: block;
`;

const DoItem = ({ headline, icon, children }) => (
  <Col>
    <Header>
      <Img src={icon} />
      <HeaderHeadline>
        <SubHeadline color="yellow">{headline}</SubHeadline>
      </HeaderHeadline>
    </Header>
    <Content>
      <Paragraph color="white">{children}</Paragraph>
    </Content>
  </Col>
);

DoItems.DoItem = DoItem;
DoItems.Row = Row;

export default DoItems;



// WEBPACK FOOTER //
// ./src/components/DoItems.js